// Help.js

import React from 'react'
import './Help.css';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import YunHeader from '../Common/YunHeader/YunHeader';
import YunIcon from '../Common/YunIcon/YunIcon';

import Snackbar from '@material-ui/core/Snackbar';

import { cppCloseWindow, setWindowTitle, cppSetWindowIcon } from '../../api/cpp';

import getProductInfo from '../../static/getProductInfo';

class Help extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            productInfo: {},
        };

        this.textCopied = this.textCopied.bind(this)
        this.closeSnackbar = this.closeSnackbar.bind(this)
    }

    textCopied(text) {
        this.setState({
            open: true,
        })
    }

    closeSnackbar() {
        this.setState({
            open: false,
        })
    }

    componentDidMount() {
        setWindowTitle('客服');
        
        getProductInfo().then(productInfo => {
            this.setState({
                productInfo: productInfo,
            })
            cppSetWindowIcon(productInfo.WindowIconFileName);
        })
        
        // 监听别的页面的通知消息
        try {
            window.onRecvBroadcastWndMsg = (msg) => {
                if (msg === 'Login_In') {
                    // 回到登录页面时，关闭此页面
                    cppCloseWindow()
                }
                // 关闭页面
                if (msg === 'Close_App') {
                    cppCloseWindow()
                }
            }
        } catch (error) {
        }
    }

    render() {
        const handleClose = () => {
            cppCloseWindow()
        }
        const ContactList = [];

        if (this.state.productInfo.helpPhone) {
            ContactList.push(
                <div className="ContactItem" key="ContactItem-PhoneItem">
                    <YunIcon icon="phoneIcon"></YunIcon>
                    <div className="Title">电　话</div>
                    <div>：</div>
                    <div className="Type">{this.state.productInfo.helpPhone}</div>
                    <CopyToClipboard text={this.state.productInfo.helpPhone} onCopy={this.textCopied}>
                        <YunIcon iconClass="Copy" icon="copyIcon"></YunIcon>
                    </CopyToClipboard>
                </div>
            )
        }

        if (this.state.productInfo.helpQq) {
            ContactList.push(
                <div className="ContactItem" key="ContactItem-QqItem">
                    <YunIcon icon="qqIcon"></YunIcon>
                    <div className="Title">Q　Q</div>
                    <div>：</div>
                    <div className="Type">{this.state.productInfo.helpQq}</div>
                    <CopyToClipboard text={this.state.productInfo.helpQq} onCopy={this.textCopied}>
                        <YunIcon iconClass="Copy" icon="copyIcon"></YunIcon>
                    </CopyToClipboard>
                </div>
            )
        }

        if (this.state.productInfo.helpWeiXin) {
            ContactList.push(
                <div className="ContactItem" key="ContactItem-WxItem">
                    <YunIcon icon="wxIcon"></YunIcon>
                    <div className="Title">微信号</div>
                    <div>：</div>
                    <div className="Type">{this.state.productInfo.helpWeiXin}</div>
                    <CopyToClipboard text={this.state.productInfo.helpWeiXin} onCopy={this.textCopied}>
                        <YunIcon iconClass="Copy" icon="copyIcon"></YunIcon>
                    </CopyToClipboard>
                </div>
            )
        }

        return (
            <div className="Help AppContainer">
                <YunHeader handleClose={handleClose} hideOnTop hideMin productInfo={this.state.productInfo} title="客服"></YunHeader>
                <div className="Tips">
                    <p>遇到任何问题，请通过以下方式联系客服。</p>
                </div>
                <div className="Contact">
                    {ContactList}
                </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={this.state.open}
                    autoHideDuration={1000}
                    onClose={this.closeSnackbar}
                    message="复制成功"
                />
            </div>
        )
    }
}

export default Help;
